/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import {
  TextField,
  makeStyles,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
// import { users, groups, roles } from "../mocks/utils";
import Actions from "../../../fluid/Actions/ActionFactory";
import SnackBar from "../../Snackbar/index";
import { Visibility, VisibilityOff } from "@material-ui/icons";

const useStyles = makeStyles(() => ({
  textField: {
    marginTop: "5px",
    borderRadius: "5px",
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        border: "1px solid #707070",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #707070",
      },
    },
  },

  dropdown: {
    "& .MuiOutlinedInput-input": {
      padding: "10px",
      "&:hover fieldset": {
        border: "1px solid #707070",
      },
      "&.Mui-focused fieldset": {
        border: "1px solid #707070",
      },
    },
  },
}));

export const InputField = (props) => {
  const classes = useStyles();
  const {
    size,
    placeholder,
    name,
    value,
    onChange,
    type,
    showPassword,
    setshowPassword,
    confirmPassword,
    setconfirmPassword,
    ...rest
  } = props;
  return (
    <TextField
      className={classes.textField}
      name={name}
      size={size}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      variant="outlined"
      InputProps={{
        endAdornment:
          name === "password" ? (
            <InputAdornment position="end">
              <IconButton
                style={{ background: "none" }}
                edge="end"
                disableRipple={true}
                onClick={() => {
                  setshowPassword(true);
                }}
                onMouseDown={() => {
                  setshowPassword(false);
                }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : name === "confirmPassword" ? (
            <InputAdornment position="end">
              <IconButton
                style={{ background: "none" }}
                edge="end"
                disableRipple={true}
                onClick={() => {
                  setconfirmPassword(true);
                }}
                onMouseDown={() => {
                  setconfirmPassword(false);
                }}
              >
                {confirmPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : (
            ""
          ),
      }}
      {...rest}
    />
  );
};

export const ListMap = ({ list, handleRemoveValues }) => {
  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        overflow: "auto",
      }}
    >
      {list?.map((item, index) => (
        <div
          style={{
            padding: "5px 15px",
            margin: "10px",
            background: "#FFFFFF",
            color: "#222222",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "5px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {item?.name ? item?.name : "Unknown"}
          <IconButton
            style={{
              fontSize: "15px",
              color: "#FF0000",
              background: "none",
              cursor: "pointer",
            }}
            disableRipple={true}
            onClick={() => handleRemoveValues(item)}
          >
            <CloseOutlined />
          </IconButton>
        </div>
      ))}
    </div>
  );
};

function GetUnSelectedList(mainList, subList) {
  // console.log("main.....", mainList);
  // console.log("sub.....", subList);
  const subListKeys = subList?.map((item) => item.name);
  for (let i = 0; i < subListKeys?.length; i++) {
    mainList?.map((item) => {
      if (subListKeys[i] === item.name) {
        mainList.splice(mainList.indexOf(item), 1);
      }
    });
  }
  return mainList;
}

export const BoxContainer = ({
  userType,
  title,
  leftBox,
  setLeftBox,
  rightBox,
  setRightBox,
}) => {
  const classes = useStyles();
  // console.log("----------->", title);
  const [allData, setAllData] = useState(null);
  const [actualList, setActualList] = useState([]);
  const [open, setopen] = useState(false);
  const [disable, setdisable] = useState(false);
  useEffect(() => {
    let api_object = {
      url : "",
      method : ""
    }

    if (title === "Users") {
      api_object.url = "/sainapse/user"
      api_object.method  = "get"
    } else if (title === "Groups") {
      api_object.url = "/sainapse/group"
      api_object.method  = "get"
    } else if (title === "Roles") {
      api_object.url = "/sainapse/role"
      api_object.method  = "get"
    }

    Actions("http_request", api_object)
      .then((res) => {
        // console.log("res............", res);
        // let temp = {
        //   users: res[0].data?.result,
        //   groups: res[1].data?.result
        //   // roles: res[2].data?.result,
        // };
        // setAllData(temp);
        setActualList(res.data?.result)
        // if (title === "Users") {
        //   setActualList(res.data?.result);
        // } else if (title === "Groups") {
        //   setActualList(res.data?.result);
        // } else if (title === "Roles") {
        //   setActualList(res[2].data?.result);
        // }
        // console.log("..../////.....", temp);
      })
      .catch((err) => {
        console.log("err..", err.message);
      });
  }, [userType]);

  console.log("allData", allData);
  if (userType === "new" || userType === "exist")  {
    if (title === "Users") {
      const uu = GetUnSelectedList(allData?.users, leftBox);
      // console.log("uu---->", uu);
    } else if (title === "Groups") {
      const ug = GetUnSelectedList(allData?.groups, leftBox);
      // console.log("ug---->", ug);
    } else if (title === "Roles") {
      const ur = GetUnSelectedList(allData?.roles, rightBox);
      // console.log("ur---->", ur);
    }
  }
  const [value, setValue] = useState(null);

  const handleAddValues = () => {
    if (value !== null) {
      if (title === "Users") {
        let grpTemp = leftBox?.length ? [...leftBox] : [];
        grpTemp.push(value);
        setLeftBox(grpTemp);

        let filteredList = actualList?.filter((item) => item !== value);
        setActualList(filteredList);
      }
      if (title === "Groups") {
        let grpTemp = leftBox?.length ? [...leftBox] : [];
        grpTemp.push(value);
        setLeftBox(grpTemp);

        let filteredList = actualList?.filter((item) => item !== value);
        setActualList(filteredList);
      }
      if (title === "Roles") {
        let roleTemp = rightBox?.length ? [...rightBox] : [];
        roleTemp.push(value);
        setRightBox(roleTemp);
        let filteredList = actualList?.filter((item) => item !== value);
        setActualList(filteredList);
      }
      setValue(null);
    } else {
      setopen(true);
    }
  };
  const onClose = () => {
    setopen(false);
  };
  const handleRemoveValues = (value) => {
    console.log("../", value);
    // const tempList = actualList && [...actualList];
    // tempList.push(value);
    // setActualList(tempList);

    if (title === "Users") {
      let filteredList = leftBox.filter((item) => item !== value);
      setLeftBox(filteredList);
    }
    if (title === "Groups") {
      let filteredList = leftBox.filter((item) => item !== value);
      setLeftBox(filteredList);
    }
    if (title === "Roles") {
      let filteredList = rightBox.filter((item) => item !== value);
      setRightBox(filteredList);
    }
  };
  console.log("actualList", actualList);
  useEffect(() => {
    if (value !== null) {
      setdisable(false);
    } else {
      setdisable(true);
    }
  }, [value]);
  return (
    <div
      style={{
        height: "100%",
        background: "#f6f6f6",
        boxShadow: "0px 3px 6px #00000029",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          borderBottom: "1px solid #00000029",
          background: "#FFFFFF",
          color: "#222222",
          fontWeight: "bold",
          padding: "10px",
        }}
      >
        {title}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "5px 0px",
        }}
      >
        <FormControl style={{ width: "100%", padding: "0px 10px" }}>
          {/* <InputLabel htmlFor="select">{`Select ${title}`}</InputLabel> */}
          <Select
            id="select"
            value={value}
            displayEmpty
            onChange={(e) => setValue(e.target.value)}
            placeholder="Select"
            fullWidth
            variant="outlined"
            className={classes.dropdown}
            disabled={actualList?.length === 0 && true}
            renderValue={(selected) => {
              if (value === null) {
                return <em style={{ color: "#6F7070" }}>Add {title}</em>;
              } else {
                return selected.name;
              }
            }}
          >
            {(userType === "new"? actualList : GetUnSelectedList(actualList, leftBox))?.map((item, index) => (
              <MenuItem key={index} value={item}>
                {item?.name ? item.name : "Unknown"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <div>
          <IconButton
            style={{
              fontSize: "18px",
              color: disable ? "#62666e" : "#0CD02A",
              paddingRight: "20px",
              background: "none",
            }}
            disableRipple={true}
            onClick={handleAddValues}
            disabled={disable}
          >
            <PlusOutlined />
          </IconButton>
        </div>
      </div>
      <div
        style={{
          height: "80%",
          overflow: "hidden",
        }}
      >
        {title === "Users" ? (
          <ListMap list={leftBox} handleRemoveValues={handleRemoveValues} />
        ) : title === "Groups" ? (
          <ListMap list={leftBox} handleRemoveValues={handleRemoveValues} />
        ) : title === "Roles" ? (
          <ListMap list={rightBox} handleRemoveValues={handleRemoveValues} />
        ) : null}
      </div>
      {open && (
        <SnackBar
          openDialog={open}
          message={"Please Select any Options"}
          onclose={onClose}
          severity={"error"}
        />
      )}
    </div>
  );
};

// export const BoxContainer = React.memo(BoxWrapper);
// export const ListMap = React.memo(MapList);
// export const InputField = React.memo(MuiInput);
